import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { jsx as _jsx } from "react/jsx-runtime";
import { useDevice, useOverlayContext } from 'seagull';
import { BillClientModal } from '~/components/BillModal/BillClientModal/BillClientModal';
import { GlobalBillModal } from '~/components/BillModal/GlobalBillModal/GlobalBillModal';
import { useBillModalLauncher } from '~/components/BillModal/hooks/useBillModalLauncher';
import { useFeatureFlags } from '~/hooks/useFeatureFlags';
import { useStoreActions } from '~/store/store-context';
export function useGlobalBillClient() {
    const { showModal, hideBottomSheet } = useOverlayContext();
    // eslint-disable-next-line no-restricted-syntax -- WHY: mirrors showModal's internal sheet-vs-modal device decision to close a stale quick-actions sheet; not layout branching
    const { isMobileDevice } = useDevice();
    const { logBI } = useStoreActions();
    const { BILL_MODAL_V2 } = useFeatureFlags();
    const { openAdHocBill } = useBillModalLauncher();
    const handleOpenBillClient = async (context)=>{
        showModal({
            biName: 'bill_client_modal',
            closeOnClickOutside: true,
            closeOnEscapeKey: true,
            content: (param)=>{
                let { dismissModal } = param;
                return /*#__PURE__*/ _jsx(BillClientModal, _object_spread({
                    dismissModal: dismissModal
                }, context));
            }
        });
    };
    return {
        openGlobalBillModal: ()=>{
            logBI(10351);
            const opensInBottomSheet = BILL_MODAL_V2 && isMobileDevice;
            if (!opensInBottomSheet) hideBottomSheet();
            showModal({
                biName: 'global_bill_modal',
                closeOnClickOutside: true,
                closeOnEscapeKey: true,
                openBottomSheetOnMobile: BILL_MODAL_V2,
                hideBottomSheetOnDismiss: true,
                content: (param)=>{
                    let { dismissModal } = param;
                    return /*#__PURE__*/ _jsx(GlobalBillModal, {
                        dismissModal: dismissModal,
                        handleOpenBillClient: handleOpenBillClient,
                        handleOpenAdHocBill: openAdHocBill
                    });
                }
            });
        }
    };
}
